import React from "react";

// Selo "Verificado pela Everlog" (épico PO1-3527, H2 PO1-3529). Ligado só por
// admin Everlog; o embarcador vê, não muda. Molde do cotacao/FonteBadge.jsx:
// estilo inline por token, para valer também na página pública (sem styles.css).
export default function SeloVerificado({ verificado, style }) {
  if (!verificado) return null;
  return (
    <span
      title="Cadastro verificado pela Everlog"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        marginLeft: 8,
        fontSize: "0.68rem",
        fontWeight: 700,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        padding: "2px 8px",
        borderRadius: 999,
        border: "1px solid var(--everlog-status-success, #00bf9a)",
        color: "var(--everlog-status-success, #00bf9a)",
        background: "color-mix(in srgb, var(--everlog-status-success, #00bf9a) 12%, transparent)",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        ...style,
      }}
    >
      <span aria-hidden="true">✓</span> Verificado pela Everlog
    </span>
  );
}
